<template>
  <div class="SecuritySet">
    <h1>安全设置</h1>
    <a-form class="bs-form">
      <a-form-item label="账号">
        <a-input v-if="acount" v-model="acount" :maxLength="30" disabled>
          <div slot="prefix">
            <a-icon style="color: #1890ff; vertical-align: middle" type="tablet" />
          </div>
        </a-input>
        <a-input value="暂无账号请绑定" v-else>
          <div slot="prefix">
            <a-icon style="color: #1890ff; vertical-align: middle" type="tablet" />
          </div>
          <a href="javaScript:;" @click="isAccount = true" slot="suffix">绑定账号</a>
        </a-input>
      </a-form-item>
      <a-form-item label="账户密码">
        <a-input name="phone" readonly="readonly" type="password" value="123456789">
          <div slot="prefix">
            <a-icon style="color: #1890ff; vertical-align: middle" type="lock" />
          </div>
          <a href="javaScript:;" @click="isPass = true" slot="suffix">修改密码</a>
        </a-input>
      </a-form-item>
      <a-form-item label="绑定手机">
        <a-input name="name" readonly="readonly">
          <div slot="prefix">
            <a-icon style="color: #1890ff; vertical-align: middle" type="tablet" />
            <span style="margin-left: 10px; color: #999999"
              >已绑定手机：<span>{{ phone.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2') }}</span></span
            >
          </div>
          <a href="javaScript:;" @click="isPhone = true" slot="suffix">修改手机</a>
        </a-input>
      </a-form-item>
    </a-form>
    <!-- 修改密码 -->
    <a-modal v-model="isPass" title="修改密码" @ok="passOk" @cancel="passcloseModle">
      <a-form-model ref="passForm" :model="passForm" :rules="passRules" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
        <a-form-model-item ref="mobile" label="手机号" prop="mobile">
          <a-input v-model="passForm.mobile" disabled />
        </a-form-model-item>
        <!-- <a-form-model-item ref="code" label="验证码" prop="code">
          <a-input v-model="passForm.code"/>
          <span :class='passDisabled ? "dis getCode" : "getCode"' @click="getCode()">{{codeText.pass}}</span>
        </a-form-model-item> -->
        <a-form-model-item ref="password" label="新密码" prop="password">
          <a-input-password v-model="passForm.password" />
        </a-form-model-item>
        <a-form-model-item ref="newpassword" label="确认密码" prop="newpassword">
          <a-input-password v-model="passForm.newpassword" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 修改手机号 -->
    <a-modal v-model="isPhone" title="修改手机号" @ok="phoneOk" @cancel="phonecloseModle">
      <a-form-model ref="phoneForm" :model="phoneForm" :rules="phoneRules" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
        <a-form-model-item ref="oldPhoneNumber" label="手机号" prop="oldPhoneNumber">
          <a-input v-model="phoneForm.oldPhoneNumber" disabled />
        </a-form-model-item>
        <a-form-model-item ref="phoneNumber" label="新手机号" prop="phoneNumber">
          <a-input v-model="phoneForm.phoneNumber" />
        </a-form-model-item>
        <!-- <a-form-model-item ref="code" label="验证码" prop="code">
          <a-input v-model="phoneForm.code"/>
          <span :class='phoneDisabled ? "dis getCode" : "getCode"' @click="getPhoneCode()">{{codeText.pho}}</span>
        </a-form-model-item> -->
      </a-form-model>
    </a-modal>
    <!-- 修改手机号 -->
    <a-modal v-model="isAccount" title="绑定账号" @ok="accountOk" @cancel="accountcloseModle">
      <a-form-model ref="accountForm" :model="accountForm" :rules="accountRules" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
        <a-form-model-item ref="account" label="账号" prop="account">
          <a-input v-model="accountForm.account" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'SecuritySet',
  props: ['baseInfo'],
  data() {
    return {
      acount: '',
      phone: '',
      isPass: false,
      info: '',
      passForm: {
        mobile: '',
        password: '',
        id: '',
        newpassword: '',
      },
      passRules: {
        phone: [{ required: true, message: '请填写手机号', trigger: 'blur' }],
        // code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        password: [{ required: true, message: '请输入6至20位字符', trigger: 'blur' }],
        newpassword: [{ required: true, message: '请输入6至20位字符', trigger: 'blur' }],
      },
      isPhone: false,
      phoneForm: {
        oldPhoneNumber: '',
        phoneNumber: '',
      },
      phoneRules: {
        oldPhoneNumber: [{ required: true, message: '请填写手机号', trigger: 'blur' }],
        // code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        phoneNumber: [{ required: true, message: '请填写新手机号', trigger: 'blur' }],
      },
      isAccount: false,
      accountForm: {
        account: '',
      },
      accountRules: {
        account: [{ required: true, message: '请填写账号', trigger: 'blur' }],
      },
      codeText: {
        pass: '获取验证码',
        pho: '获取验证码',
      },
      passDisabled: false,
      phoneDisabled: false,
      userId: '',
    }
  },
  created() {
    ;(this.userId = this.$store.getters['account/user'].id), this.getAdminInfo()
  },
  methods: {
    passcloseModle() {
      this.$refs.passForm.resetFields()
    },
    phonecloseModle() {
      this.$refs.phoneForm.resetFields()
    },
    accountcloseModle() {
      this.$refs.accountForm.resetFields()
    },
    getAdminInfo() {
      let parmas = {
        adminId: this.userId,
      }
      this.$http.getAdminInfo(parmas).then((res) => {
        this.info = res.data.data
        ;(this.acount = this.info.account),
          (this.phone = this.info.mobile),
          (this.passForm.mobile = this.info.mobile),
          (this.passForm.id = this.info.id),
          (this.phoneForm.oldPhoneNumber = this.info.mobile)
      })
    },
    passOk() {
      this.$refs.passForm.validate((valid) => {
        if (valid) {
          if (!/^[1][3,4,5,7,8,9][0-9]{9}$/.test(this.passForm.mobile)) {
            this.$message.error('请输入正确的手机号')
          } else if (!/^([a-z0-9\.\@\!\#\$\%\^\&\*\(\)]){6,20}$/i.test(this.passForm.password)) {
            this.$message.error('请输入格式正确的密码')
          } else if (this.passForm.password != this.passForm.newpassword) {
            this.$message.error('两次输入密码不一致')
          } else {
            let params = {
              password: this.passForm.password,
              id: this.passForm.id,
            }
            this.$http.updatePass(params).then((res) => {
              this.$message.success('修改成功，请重新登录')
              this.$router.push('/login')
            })
          }
        }
      })
    },
    getCode() {
      let formData = new FormData()
      formData.append('phone', this.passForm.phone)
      this.$http.getCode(formData).then((res) => {
        this.timeOut('pass')
        this.passDisabled = true
        this.$message.success('验证码已发送，请注意查收')
      })
    },
    getPhoneCode() {
      let formData = new FormData()
      formData.append('phone', this.phoneForm.phoneNumber)
      formData.append('isold', false)
      this.$http.getPhoneCode(formData).then((res) => {
        this.timeOut('pho')
        this.phoneDisabled = true
        this.$message.success('验证码已发送，请注意查收')
      })
    },
    phoneOk() {
      this.$refs.phoneForm.validate((valid) => {
        if (valid) {
          if (!/^[1][3,4,5,7,8,9][0-9]{9}$/.test(this.phoneForm.phoneNumber)) {
            this.$message.destroy()
            this.$message.error('请输入正确的手机号')
          } else if (this.phoneForm.oldPhoneNumber == this.phoneForm.phoneNumber) {
            this.$message.destroy()
            this.$message.error('新手机号不能与旧手机号相同')
          } else {
            let params = {
              mobile: this.phoneForm.phoneNumber,
              id: this.info.id,
            }
            this.$http.updateMobile(params).then((res) => {
             
                this.$message.success('修改成功')
                this.isPhone = false
                this.phoneForm = {
                  oldPhoneNumber: this.info.mobile,
                  phoneNumber: '',
                }
                // this.codeText['pho'] = "获取验证码";
                this.phoneDisabled = false
                this.getAdminInfo()
            })
          }
        }
      })
    },
    accountOk() {
      this.$refs.accountForm.validate((valid) => {
        if (valid) {
          // if (!/^[1][3,4,5,7,8,9][0-9]{9}$/.test(this.phoneForm.phoneNumber)) {
          //   this.$message.destroy()
          // 	this.$message.error('请输入正确的手机号')
          // } else {
          let params = {
            account: this.accountForm.account,
            id: this.info.id,
          }
          this.$http.updateAccount(params).then((res) => {
              this.$message.success('绑定成功')
              this.isAccount = false
              this.getAdminInfo()
          })
          // }
        }
      })
    },
    timeOut(name) {
      let t = 60
      const time = setInterval(() => {
        this.codeText[name] = t-- + '重新获取'
        if (t <= 0) {
          clearInterval(time)
          this.codeText[name] = '获取验证码'
          this.passDisabled = false
          this.phoneDisabled = false
        }
      }, 1000)
    },
  },
}
</script>

<style scoped lang="less">
.bs-form {
  width: 30%;
}
.bs-form /deep/ .ant-input {
  pointer-events: none;
}
.getCode {
  position: absolute;
  right: 15px;
  color: #13c2c2;
  cursor: pointer;
}
.dis {
  pointer-events: none;
}
</style>
